import React from 'react';

import DataConnector from 'connect/DataConnector';

import type {ModelHubRoute} from './modelHubRoutes';
import ModelHubRouteStore from './ModelHubRouteStore';
import {ScientificModelsView} from './scientific-models/ScientificModelsView';

interface ModelHubScreenEnhancedProps {
  currentRoute: ModelHubRoute | null;
}

class ModelHubScreenConnector extends DataConnector<{}, ModelHubScreenEnhancedProps> {
  override shouldSubscribeToRedux = false;
  override stores = [ModelHubRouteStore];

  enhanceProps(): ModelHubScreenEnhancedProps {
    return {currentRoute: ModelHubRouteStore.getCurrentRoute()};
  }
}

// `currentRoute` is supplied by the connector but deliberately unread for now: every entry point
// renders the legacy tabbed view, so core behavior is unchanged. BNCH-168599 adds the
// `MODEL_HUB_ENABLE_REDESIGNED_UI` flag and branches three ways on it — a null route (the legacy
// `/model-hub` URL) keeps this view; a canonical route renders the redesigned page when the flag is
// on, and falls back to this view when it is off.
function ModelHubScreen(): JSX.Element {
  return <ScientificModelsView />;
}

export default ModelHubScreenConnector.connect(ModelHubScreen);
